export const shouldDisableAnimations = (): boolean => {
  if (typeof window === 'undefined') return false;

  const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const disableAnimations = window.__DISABLE_ANIMATIONS__ === true;

  return disableAnimations || prefersReducedMotion;
};
